// @ts-nocheck
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles, spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface AttributesProps {
    wrapper?: InjectableCss;
    container?: GridContainerProps;
    innerWrapper?: InjectableCss;
    item?: GridItemProps;
    label?: TypographyPresentationProps;
    value?: TypographyPresentationProps;
}

export const attributeSpacing = pxToRem(4);

const baseStyles = () => css`
    color: ${getColor("text.accent")};

    ${({ theme }) => css`
        font-size: ${theme.design.typography.size.smaller};
        line-height: ${theme.design.typography.lineHeight.small};
    `}
`;

export const attributesProps: AttributesProps = {
    wrapper: {
        /* Bunzl custom code Start */
        css: css`
            display: flex;
            gap: ${pxToRem(4)};
            flex-direction: column;
            ${baseStyles()}
        `,
        /* Bunzl custom code End */
    },
    container: {
        gap: 0,
        css: css`
            ${gridGapStyles([], [attributeSpacing])}
            ${baseStyles()}
        `,
    },
    innerWrapper: {
        css: css`
            display: block;
            /* Buzl removed code */
        `,
    },
    item: {
        width: 12,
        css: css`
            flex-flow: wrap;
        `,
    },
    label: {
        css: css`
            margin-right: 0.3em;
        `,
    },
    value: {
        css: css`
            word-break: break-all;
        `,
    },
};
